import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from './pmd-datepicker.config';

@Injectable()
export class BsDaterangepickerInlineConfig extends BsDatepickerConfig {
    // DatepickerRenderOptions
    displayMonths = 2;
    /** turn on/off animation */
    isAnimated = false;
}
